/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var R = require("ramda");
var util = require("./util");
var stringUtil = require("../util/string");
var numberUtil = require("../util/number");

//-------------------------------------------
// Creates a comparator function that treats
// null as the lowest value.
function createNullComparator(getValue) {
    return function nullComparator(x, y) {
        var xValue = getValue(x);
        var yValue = getValue(y);

        if (xValue === yValue) { return 0; }
        if (xValue === null) { return -1; }
        if (yValue === null) { return 1; }
        return (xValue < yValue ? -1 : 1);
    };
}


//-------------------------------------------
// Gets a lower-case value and handles `null`
// or `undefined` at any level. Switched from
// using ramdajs to compose the function to
// improve performance for older IE browsers.
function createCaseInsensitiveGet(field) {
    return function getCaseInsensitiveValue(value) {
        if (value === null || value === undefined) { return ""; }
        var fieldValue = value[field];
        if (fieldValue === null || fieldValue === undefined) { return ""; }
        return fieldValue.toString().toLowerCase();
    };
}


//-------------------------------------------
// Creates a comparator function that performs
// a case-insensitive string comparison.
function createCaseInsensitiveComparer(field) {
    var getValue = createCaseInsensitiveGet(field);
    return function caseInsensitiveComparer(x, y) {
        var xValue = getValue(x);
        var yValue = getValue(y);
        return xValue === yValue ? 0 : (xValue < yValue ? -1 : 1);
    };
}


//-------------------------------------------
// Creates a comparator function that performs
// an object comparison.
function createCaseSensitiveComparer(field) {
    return createNullComparator(util.propOrDefault(field, null));
}


//-------------------------------------------
// Creates a comparator function that performs
// converts the value to a number and compares it.
function createNumberComparer(field) {
    return createNullComparator(R.compose(numberUtil.parseNumber, util.propOrDefault(field, null)));
}


//-------------------------------------------
// Transforms two comparator functions into a
// single function. The right function is
// executed if the result of the left equals `0`.
function composeComparator(left, right) {
    return function (x, y) {
        var result = left(x, y);
        return (result === 0 ? right(x, y) : result);
    };
}


//-------------------------------------------
// Transforms an array of comparator functions
// into a single function.
function composeComparators(comparators) {
    var result = function () { return 0; };
    var i, l = comparators.length;
    for (i = 0; i < l; i += 1) {
        result = composeComparator(result, comparators[i]);
    }
    return result;
}


//-------------------------------------------
// Default implementation of the resolver factory
// accepts a string id and returns a comparer function.
function defaultFactory(id) {
    if (stringUtil.isNullOrWhitespace(id)) { throw new Error("comparer factory id must be a string."); }
    var pair = id.split(":");
    var comparerType = (pair[1] || "").toLowerCase();
    var comparerField = pair[0];
    var comparer;
    switch (comparerType) {
    case "default":
        comparer = createCaseInsensitiveComparer(comparerField);
        break;
    case "number":
        comparer = createNumberComparer(comparerField);
        break;
    case "sensitive":
        comparer = createCaseSensitiveComparer(comparerField);
        break;
    default:
        throw new Error("`".concat(comparerType, "` comparer type is not supported."));
    }
    return comparer;
}


//-------------------------------------------
// Accepts a factory function and returns a function
// that resolves a comparator.
function initFactory(factory) {
    return function comparerResolver(context, value, isDescending) {
        var comparer;
        if (Array.isArray(value)) {
            var i, l = value.length, result = [];
            for (i = 0; i < l; i += 1) {
                result.push(comparerResolver(context, value[i]));
            }
            comparer = composeComparators(result);
        } else if (typeof value === "function") {
            comparer = value;
        } else {
            comparer = factory.call(context, value);
        }
        return R.bind((isDescending ? R.compose(R.multiply(-1), comparer) : comparer), context);
    };
}


module.exports = {
    composeComparators: composeComparators,
    defaultFactory: initFactory(defaultFactory),
    init: initFactory
};




//////////////////
// WEBPACK FOOTER
// ./~/pli/ko-grid/comparerFactory.js
// module id = 421
// module chunks = 49